import { render } from "./Loader.vue?vue&type=template&id=ac7f1726&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__